module.exports = {
  label: {
    heading: 'Sign Up',
    userName: 'Username',
    passport: "ID/Passport",
    password: 'Password',
    name: 'Name',
    surname: 'Surname',
    emailAddress: 'Email Address',
    phoneNumber: 'Cell Phone Number',
    WhatsAppNumber: 'WhatsApp Number',
    uploadPhoto: 'Upload Your Photo',
    communicationType: 'Communication Type',
    allowShareInformation: 'By submitting this form and information consents to the transfer, processing, or storage of such Personal Information.',
    notAllowedShareInformation: 'You cannot proceed with your registration.',
    alreadyAccount: "Already have an account?",
    login: "Login Here",
    buttons: {
      signUp: 'Sign Up'
    }
  }
}
